"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayHowToEarnPointsModal = void 0;
const moduleIds_1 = require("root/src/shared/descriptions/modules/moduleIds");
const displayModal_1 = __importDefault(require("root/src/client/logic/modal/actions/displayModal"));
const getUserDropEventLandingShortUrl_1 = require("root/src/client/logic/dropEvent/thunks/getUserDropEventLandingShortUrl");
const creatorCampaignPointsLimitSelector_1 = __importDefault(require("root/src/client/logic/app/selectors/creatorCampaignPointsLimitSelector"));
const userCampaignDataSelector_1 = __importDefault(require("root/src/client/logic/app/selectors/userCampaignDataSelector"));
const platformIdSelector_1 = __importDefault(require("root/src/client/logic/userData/selectors/platformIdSelector"));
const dropEventSelector_1 = __importDefault(require("root/src/client/logic/dropEvent/selectors/dropEventSelector"));
const canEarnPointsSelector_1 = __importDefault(require("root/src/client/logic/dropEvent/selectors/canEarnPointsSelector"));
const displayHowToEarnPointsModal = (params) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const dropEvent = (0, dropEventSelector_1.default)(state);
    const canEarnPoints = (0, canEarnPointsSelector_1.default)(state);
    const creatorCampaignPointsLimit = (0, creatorCampaignPointsLimitSelector_1.default)(state);
    const userCampaignData = (0, userCampaignDataSelector_1.default)(state);
    const platformId = (0, platformIdSelector_1.default)(state);
    const shortUrl = yield (0, getUserDropEventLandingShortUrl_1.getUserDropEventLandingShortUrl)(dropEvent.id)(dispatch, getState);
    dispatch((0, displayModal_1.default)(moduleIds_1.HOW_TO_EARN_POINTS_MODAL_MODULE_ID, Object.assign(Object.assign({}, params), { shortUrl,
        userCampaignData,
        creatorCampaignPointsLimit,
        platformId,
        dropEvent,
        canEarnPoints })));
});
exports.displayHowToEarnPointsModal = displayHowToEarnPointsModal;
